<div class="form-subcontainer">
    <div class="form-content">
        <!-- <div class="form-header">
            <button clickable="" class="btn-close"><svg xmlns="http://www.w3.org/2000/svg" width="17.657"
                    height="17.657" viewBox="0 0 17.657 17.657">
                    <g _ngcontent-kcr-c822="" id="Group_12987" data-name="Group 12987"
                        transform="translate(-5669.475 -484.975)">
                        <line _ngcontent-kcr-c822="" id="Line_325" data-name="Line 325" x2="12" y2="12"
                            transform="translate(5672.304 487.804)" fill="none" stroke="#bebfbe" stroke-linecap="round"
                            stroke-width="4"></line>
                        <line _ngcontent-kcr-c822="" id="Line_326" data-name="Line 326" x1="12" y2="12"
                            transform="translate(5672.304 487.804)" fill="none" stroke="#bebfbe" stroke-linecap="round"
                            stroke-width="4"></line>
                    </g>
                </svg></button>
            <h2 class="form-title">About Us</h2>
        </div> -->
        <div>
            <form class="fpx-form-group">
                <section class="aboutus-container">
                    <div class="expand-text">
                        <div class=""><b> Lorem Ipsum is simply dummy text?</b></div>
                         <div>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type</div>
                     </div>
                     <div class="expand-text">
                        <div class=""> <b>Lorem Ipsum is simply dummy text?</b></div>
                         <div>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type</div>
                     </div>
                     <div class="expand-text">
                        <div class="arrow1"><b> Lorem Ipsum is simply dummy text?</b></div>
                         <div>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type</div>
                     </div>
                    </section>
            </form>
        </div>
    </div>
</div>